import { render, staticRenderFns } from "./AppealsStatusReport.vue?vue&type=template&id=40548784"
import script from "./AppealsStatusReport.vue?vue&type=script&lang=js"
export * from "./AppealsStatusReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports